
const digest = '40fc2c736a84814aa5cf336d9be843f77351a616718825faa3b65d798cd43c37';
const classes = {"wrapper":"_wrapper_11d7g_1","header":"_header_11d7g_9","date":"_date_11d7g_20","document":"_document_11d7g_24","options":"_options_11d7g_27","list":"_list_11d7g_37","item":"_item_11d7g_43","title":"_title_11d7g_61"};
const css = `._wrapper_11d7g_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
}
._wrapper_11d7g_1 ._header_11d7g_9 {
  display: flex;
  flex-direction: row;
  gap: 28px;
  padding: 6px 19px;
  font-size: 14px;
  font-weight: 500;
  background: #fbfbfd !important;
  border-right: 1px solid #eaedf3;
  border-left: 1px solid #eaedf3;
}
._wrapper_11d7g_1 ._header_11d7g_9 ._date_11d7g_20 {
  min-width: 150px;
  max-width: 150px;
}
._wrapper_11d7g_1 ._header_11d7g_9 ._document_11d7g_24 {
  flex-grow: 1;
}
._wrapper_11d7g_1 ._options_11d7g_27 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_11d7g_1 ._list_11d7g_37 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_11d7g_1 ._list_11d7g_37 ._item_11d7g_43 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_11d7g_1 ._list_11d7g_37 ._item_11d7g_43:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_11d7g_1 ._list_11d7g_37 ._item_11d7g_43 ._date_11d7g_20 {
  font-size: 14px;
  color: #000000;
  min-width: 150px;
  max-width: 150px;
}
._wrapper_11d7g_1 ._list_11d7g_37 ._item_11d7g_43 ._title_11d7g_61 {
  color: #000000;
  font-weight: 500;
  flex-grow: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  